module.exports = __webpack_public_path__ + "img/404.759d95c6.png";